// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"71":"87f04c5b","191":"43415c1b","215":"87f04c5b","249":"87f04c5b","444":"87f04c5b","517":"87f04c5b","627":"87f04c5b","752":"87f04c5b","908":"9ebe6c12","918":"87f04c5b","953":"87f04c5b","983":"87f04c5b"}[chunkId] + ".chunk.css";
};